var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUpload = function SvgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#upload_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M34.889 0H5.11A5.117 5.117 0 0 0 0 5.111V34.89A5.117 5.117 0 0 0 5.111 40H34.89A5.117 5.117 0 0 0 40 34.889V5.11A5.117 5.117 0 0 0 34.889 0m2.755 34.889a2.76 2.76 0 0 1-2.755 2.755H5.11a2.76 2.76 0 0 1-2.755-2.755V30.59l7.754-6.597a.76.76 0 0 1 .982-.006l4.857 4.033a1.18 1.18 0 0 0 1.586-.074l11.542-11.559a.76.76 0 0 1 .578-.223.76.76 0 0 1 .553.281l7.436 9.156zm0-13.025-5.607-6.903a3.12 3.12 0 0 0-2.26-1.149 3.13 3.13 0 0 0-2.368.911L16.628 25.522l-4.031-3.347a3.11 3.11 0 0 0-4.013.024l-6.228 5.299V5.11a2.76 2.76 0 0 1 2.755-2.755H34.89a2.76 2.76 0 0 1 2.755 2.755z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.592 4.921a5.687 5.687 0 0 0-5.68 5.681 5.687 5.687 0 0 0 5.68 5.68 5.687 5.687 0 0 0 5.68-5.68 5.687 5.687 0 0 0-5.68-5.68m0 9.006a3.33 3.33 0 0 1-3.325-3.325 3.33 3.33 0 0 1 3.325-3.325 3.33 3.33 0 0 1 3.324 3.325 3.33 3.33 0 0 1-3.324 3.325"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "upload_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  })))));
};
export default SvgUpload;